import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';

const Layout = ({ children }) => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    // FIX IOS: h-[100dvh] para altura dinâmica correta no Safari
    <div className="flex h-screen h-[100dvh] bg-gray-50 dark:bg-black font-inter text-foreground overflow-hidden">
      
      <Sidebar 
        isOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
        closeSidebar={closeSidebar}
      />

      {/* Área Principal */}
      <div className="flex-1 flex flex-col min-w-0 relative h-full transition-all duration-300">
        
        <Header 
          toggleSidebar={toggleSidebar}
        />

        {/* Scroll nativo suave para iOS */}
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50/50 dark:bg-black p-4 sm:p-6 md:p-8 scroll-smooth relative" style={{ WebkitOverflowScrolling: 'touch' }}>
          <div className="max-w-7xl mx-auto space-y-6">
             {children}
          </div>
        </main>
        
      </div>
    </div>
  );
};

export default Layout;